export default "__VITE_ASSET__BGdMOV60__"